// Leaderboard utilities.
//
// Primary: global leaderboard via server endpoint (/api/leaderboard) backed by Redis (Upstash).
// Fallback: localStorage game history (per device/browser/domain).

export async function submitLeaderboardEntry({
    playerName,
    points,
    mapDetails,
} = {}) {
    if (!playerName || typeof playerName !== 'string') return;
    if (!mapDetails?.id || !mapDetails?.name) return;

    const payload = {
        name: playerName.slice(0, 20),
        points: Number(points) || 0,
        mapId: mapDetails.id,
        mapName: mapDetails.name,
    };

    try {
        await fetch('/api/leaderboard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
    } catch (e) {
        // Best-effort only; never block end-of-game flow.
    }
}

export async function fetchLeaderboardEntries({ mapId = null, limit = 25 } = {}) {
    const qs = new URLSearchParams();
    if (mapId) qs.set('mapId', mapId);
    qs.set('limit', String(Math.max(1, Math.min(50, Number(limit) || 25))));

    try {
        const res = await fetch(`/api/leaderboard?${qs.toString()}`, {
            method: 'GET',
        });
        if (!res.ok) return null;
        const data = await res.json();
        if (!data || !Array.isArray(data.entries)) return null;
        return data.entries;
    } catch (e) {
        return null;
    }
}

export function getLocalHistoryLeaderboard({ mapId = null, limit = 25 } = {}) {
    let history = [];
    try {
        history = JSON.parse(localStorage.getItem('history') || '[]');
    } catch (e) {
        history = [];
    }

    const entries = history
        .filter((h) => !!h && typeof h === 'object')
        .filter((h) => (mapId ? h?.mapDetails?.id === mapId : true))
        .map((h, idx) => ({
            id: `local-${idx}`,
            name: h?.playerName || 'Anonyme',
            points: Number(h?.points) || 0,
            mapId: h?.mapDetails?.id || '',
            mapName: h?.mapDetails?.name || '',
            createdAt: h?.date ? new Date(h.date).getTime() : 0,
        }))
        .filter((e) => e.points > 0)
        .sort((a, b) => b.points - a.points || b.createdAt - a.createdAt)
        .slice(0, Math.max(1, Number(limit) || 25));

    return entries;
}
